/* Util: Flexbox fallback
========================================================================== */
function flexbox_fallback(element, breakpoint) {

    if (!Modernizr.flexbox) {

        // Make boxes the same height
        var $box = $(element),
        window_width = window.innerWidth;

        $box.css('height', 'auto');

        if($box.length) {

            if(window_width > breakpoint) {

                var items = [];

                $box.each(function() {
                    items.push($(this).innerHeight());
                });

                var largest_height = Math.max.apply(null, items);

                $box.css('height', largest_height);

            }
        }
    }
}
